import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import UserService from "apiService/permissions";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useCreateGroupPermission = (setShowAddForm) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.CREATE_GROUP_PERMISSION],
    (data) => UserService.createGroupPermission(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_PERMISSION_GROUP);
        setShowAddForm(false)
        toast.success('Group permission added successfully')
      },
      onError: (error) => {
        toast.error(error.response.data.message)
    },
    }
  );
};

export default useCreateGroupPermission